function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import PropTypes from "prop-types";
import DropContainer from './DropContainer';
import DragContainer from './DragContainer';
import { Droppable, Draggable } from "react-beautiful-dnd";

// This must be wrapped in a DragDrop/Context
function VerticalDragDropList(props) {
  const {
    children,
    renderContent,
    droppableId,
    elevation,
    collection,
    collectionIdKey,
    DropContainerProps,
    DragContainerProps,
    disabled,
    ...restProps
  } = props;
  const [focusedItemId, setFocusedItemId] = useState(null);
  if (!Boolean(collectionIdKey)) {
    throw "collectionIdKey not defined";
  }
  ;
  if (!Boolean(droppableId)) {
    throw "droppableId not defined";
  }
  ;
  const getCollectionItemId = collection_item => {
    let id = "" + collection_item[collectionIdKey];
    if (!Boolean(id)) {
      throw "item id invalid";
    }
    return id;
  };
  return /*#__PURE__*/React.createElement(Droppable, {
    isDropDisabled: disabled,
    droppableId: droppableId
  }, (dndProvided, dndSnapshot) => /*#__PURE__*/React.createElement(DropContainer, _extends({
    isEmpty: collection.length == 0,
    dndProvided: dndProvided,
    dndSnapshot: dndSnapshot,
    elevation: elevation
  }, DropContainerProps), collection.map((collection_item, index) => {
    const item_id = droppableId + getCollectionItemId(collection_item);
    return /*#__PURE__*/React.createElement(Draggable, {
      isDragDisabled: disabled,
      key: item_id,
      draggableId: item_id,
      index: index
    }, (dndProvided, dndSnapshot) => {
      const isFocused = focusedItemId == item_id;
      return /*#__PURE__*/React.createElement(DragContainer, _extends({
        onFocus: () => setFocusedItemId(item_id),
        onBlur: () => setFocusedItemId(null),
        dndProvided: dndProvided,
        dndSnapshot: dndSnapshot,
        disabled: disabled
      }, DragContainerProps), renderContent(collection_item, isFocused));
    });
  }), dndProvided.placeholder));
}
VerticalDragDropList.propTypes = {
  droppableId: PropTypes.string.isRequired,
  elevation: PropTypes.number.isRequired,
  collection: PropTypes.array.isRequired,
  collectionIdKey: PropTypes.string.isRequired,
  DropContainerProps: PropTypes.object.isRequired,
  DragContainerProps: PropTypes.object.isRequired,
  renderContent: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};
VerticalDragDropList.defaultProps = {
  elevation: 0,
  DropContainerProps: {},
  DragContainerProps: {},
  renderContent: () => {},
  disabled: false
};
export default VerticalDragDropList;